import { useMemo, useState } from 'react';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ArticleCard from '@/components/feature/ArticleCard';
import EmptyState from '@/components/feature/EmptyState';
import { useDocumentMeta } from '@/hooks/useDocumentMeta';
import { newsTags } from '@/mocks/categories';
import { filterArticles, type SortKey } from '@/utils/articles';

const PAGE_SIZE = 6;

export default function NewsPage() {
  const [activeTag, setActiveTag] = useState<string>('全部');
  const [sort, setSort] = useState<SortKey>('latest');
  const [visible, setVisible] = useState(PAGE_SIZE);

  useDocumentMeta(
    '娱乐资讯 - 91黑料娱乐黑料爆料平台',
    '91黑料娱乐资讯频道，汇集娱乐圈新闻、影视花边与活动报道，为你呈现除黑料之外的多元娱乐动态。',
  );

  const filtered = useMemo(
    () =>
      filterArticles({
        type: 'news',
        newsTag: activeTag === '全部' ? undefined : activeTag,
        sort,
      }),
    [activeTag, sort],
  );

  const shown = filtered.slice(0, visible);

  const changeTag = (tag: string) => {
    setActiveTag(tag);
    setVisible(PAGE_SIZE);
  };

  const reset = () => {
    setActiveTag('全部');
    setSort('latest');
    setVisible(PAGE_SIZE);
  };

  return (
    <div className="max-w-content mx-auto px-4 md:px-6 py-6 md:py-8">
      <Breadcrumb items={[{ label: '娱乐资讯' }]} />

      <header className="mt-5 md:mt-6">
        <h1 className="text-2xl md:text-3xl font-black text-foreground-950 flex items-center gap-3">
          <span className="w-10 h-10 rounded-lg bg-accent-500 text-background-50 flex items-center justify-center">
            <i className="ri-newspaper-line text-xl"></i>
          </span>
          娱乐资讯
        </h1>
        <p className="text-sm text-foreground-600 mt-3 max-w-3xl">
          在这里浏览除黑料爆料之外的多元娱乐新闻：行业动态、影视花边、颁奖礼与活动报道，一站式掌握娱乐圈大小事。
        </p>
      </header>

      <div className="mt-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div className="flex flex-wrap items-center gap-2">
          {['全部', ...newsTags].map((tag) => (
            <button
              key={tag}
              type="button"
              onClick={() => changeTag(tag)}
              className={`px-4 py-1.5 rounded-full text-sm transition-colors whitespace-nowrap ${
                activeTag === tag
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-700 hover:bg-background-200'
              }`}
            >
              {tag}
            </button>
          ))}
        </div>
        <div className="flex items-center gap-2">
          <span className="text-xs text-foreground-500 whitespace-nowrap">排序：</span>
          <div className="flex items-center gap-1 px-1 py-1 bg-background-100 rounded-full">
            {(['latest', 'hot'] as SortKey[]).map((s) => (
              <button
                key={s}
                type="button"
                onClick={() => {
                  setSort(s);
                  setVisible(PAGE_SIZE);
                }}
                className={`px-3 py-1 text-xs rounded-full whitespace-nowrap transition-colors ${
                  sort === s ? 'bg-primary-500 text-background-50' : 'text-foreground-600'
                }`}
              >
                {s === 'latest' ? '最新发布' : '最多热度'}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="mt-6">
        {shown.length === 0 ? (
          <EmptyState
            icon="ri-emotion-sad-line"
            title="暂无相关资讯"
            description="当前筛选条件下暂时没有内容，换个标签看看或重置筛选。"
            onAction={reset}
          />
        ) : (
          <>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
              {shown.map((article) => (
                <ArticleCard key={article.id} article={article} />
              ))}
            </div>
            {visible < filtered.length && (
              <div className="flex justify-center mt-8">
                <button
                  type="button"
                  onClick={() => setVisible((v) => v + PAGE_SIZE)}
                  className="px-6 py-2.5 rounded-md bg-background-100 text-foreground-800 text-sm font-medium hover:bg-background-200 transition-colors whitespace-nowrap flex items-center gap-2"
                >
                  <i className="ri-add-line"></i> 加载更多
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}